export default class ReadMoreToggle {
	constructor(element) {
		if (!element) return;

		this.toggler = element;
		this.entryContent = element.parentElement.parentElement.querySelector('.entry-content');
		if (!this.entryContent) return;

		this.entryContentHeight = this.entryContent.getBoundingClientRect().height;
		this.entryContentMaxHeight = parseInt(this.toggler.dataset.maxHeight);

		if ( this.entryContentHeight > this.entryContentMaxHeight) {
			this.init();
			this.events();
		}
	}

	onTogglerClick(ev) {
		ev.preventDefault();
		this.toggler.classList.toggle('toggled');

		if (this.toggler.classList.contains('toggled')) {
			this.toggler.textContent = this.toggler.dataset.closeText;
		} else {
			this.toggler.textContent = this.toggler.dataset.openText;
		}

		this.entryContent.classList.toggle('toggled');
	}

	init() {
		this.entryContent.style.maxHeight = `${this.entryContentMaxHeight}px`;
		this.entryContent.classList.add('faded');
		this.toggler.parentElement.classList.remove('d-none');
	}

	events() {
		this.toggler.addEventListener('click', this.onTogglerClick.bind(this), false );
	}
}

// Read more toggle
Array.from(document.querySelectorAll('.read-more-toggle-link')).map(el => new ReadMoreToggle(el));
